import { useListPreferences, useSetPreference } from "@/queries/user-preferences-queries";
import { useCallback } from "react";

/**
 * @param preferenceKey - The key of the preference to use
 * @returns The value of the preference and a setter that optimistically updates it
 */
export const usePreferenceValue = (preferenceKey: string) => {
    const { data: fetchedValue, ...queryData } = useListPreferences();
    const preference = fetchedValue?.preferences.find((p) => p.key === preferenceKey);

    const preferenceMutation = useSetPreference();
    const setValueAsync = useCallback(
        async (newValue: string) => {
            await preferenceMutation.mutateAsync({ key: preferenceKey, value: newValue });
        },
        [preferenceMutation, preferenceKey],
    );

    const setValue = useCallback(
        (newValue: string) => {
            setValueAsync(newValue).catch(console.error);
        },
        [setValueAsync],
    );

    return { value: preference?.value, setValue, setValueAsync, queryData };
};
